var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoSendPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GoSend Pickup Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GoSend Pickup Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.1b-Fare-Detail-CardLoaded",
    transform: "translate(-34.000000, -318.000000)",
    fill: "#00AA13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 212.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(16.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left-Icon-\\uD83D\\uDD04",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1241666,2 C14.223671,2.02864704 15.3232107,2.09932163 16.4228894,2.21202378 C19.241819,2.50223976 21.4837629,4.7459095 21.7727557,7.56700896 C22.0757481,10.5172045 22.0757481,13.4684008 21.7727557,16.4185963 C21.4837629,19.2396958 19.241819,21.4833655 16.4228894,21.7725808 C13.4739632,22.0758064 10.5260368,22.0758064 7.57711057,21.7725808 C4.75818105,21.4833655 2.51623709,19.2396958 2.22724432,16.4185963 C1.92425189,13.4684008 1.92425189,10.5172045 2.22724432,7.56700896 C2.51623709,4.7459095 4.75818105,2.50223976 7.57711057,2.21202378 C8.67645588,2.09935581 9.77566222,2.0286899 10.8748332,2.00002607 L10.8747781,3.73752439 C10.8747781,4.3588292 11.3784452,4.86249626 11.99975,4.86249626 C12.6210548,4.86249626 13.1247219,4.3588292 13.1247219,3.73752439 L13.1247219,3.73752439 Z M12,8.48969562 C11.4480138,8.48969562 11.000025,8.93802927 11.000025,9.49044038 L11.000025,9.49044038 L11.000025,14.5992424 L9.7120572,13.2922697 C9.3240669,12.898977 8.69108272,12.8939733 8.29809255,13.2822623 C7.90510237,13.6705512 7.90110247,14.3040226 8.2880928,14.6973153 L8.2880928,14.6973153 L11.2900177,17.7425816 C11.681008,18.1398773 12.321992,18.1398773 12.7139822,17.7425816 L12.7139822,17.7425816 L15.7129072,14.6963146 C16.0998975,14.3030219 16.0948976,13.6695505 15.7019075,13.2812615 C15.5069123,13.0891185 15.2539187,12.993047 14.999925,12.993047 C14.7419315,12.993047 14.4839379,13.0931215 14.2879428,13.2922697 L14.2879428,13.2922697 L12.999975,14.5992424 L12.999975,9.49044038 C12.999975,8.93802927 12.5519862,8.48969562 12,8.48969562 Z",
    id: "label/24/ic_logistic_pickup",
    transform: "translate(12.000000, 12.000000) scale(1, -1) translate(-12.000000, -12.000000) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoSendPickup);
export default __webpack_public_path__ + "static/media/go-send-pickup.0773c09c619221c1981404bb50c50103.svg";
export { ForwardRef as ReactComponent };